import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  emailInfo: {
    marginTop: spacing(4),
  },
  settingsTitle: {
    marginTop: spacing(8),
    marginBottom: spacing(4),
    display: 'flex',
    alignItems: 'center',
  },
  emailMessage: {
    opacity: 0.25,
  },
});

export default styles;
